import Vue from 'vue'
import Rights from './Rights'
function getComponent () {
  const instance = new Vue({
    render (h) {
      return h(Rights)
    }
  })
  // 手动挂载dom
  const el = instance.$mount().$el
  document.body.appendChild(el)
  return instance.$children[0]
}

export const rightDisplay = function () {
  return getComponent()
}
